import { ThumbsDown } from '@carespace-icons/alerts/thumbsDown';
import { ThumbsUp } from '@carespace-icons/alerts/thumbsUp';
import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';

const RecommendationDashboard = () => {
  const { t } = useTranslation()
  return (
    <div className="recommendations-wrapper">
      <div className="recommendations-container">
        <p className="recommendations-header">
          <span className="recommendations-title">
            {t('Patient.data.recommendations.recommendations')}
          </span>
          <span className="recommendations-description">
            {t('Patient.data.recommendations.suggestions')}
          </span>
        </p>

        <Row
          gutter={[16, 16]}
          style={{ marginTop: '16px', color: 'var(--text-color-root)' }}
        >
          <Col xs={24} sm={24} md={12} lg={8}>
            <div className="recommendation-card success stroke-primary-700">
              <div className="bg-success-50 icon-wrapper success-icon">
                <div className="bg-success-100 icon-inner success-inner">
                  <ThumbsUp color="stroke-success-600" />
                </div>
              </div>
              <p>
                <span className="bold-text">{t('Patient.data.recommendations.practiceDeep')}</span>
                <span> {t('Patient.data.recommendations.toManage')}</span>
              </p>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8}>
            <div className="recommendation-card success stroke-primary-700">
              <div className="bg-success-50 icon-wrapper success-icon">
                <div className="bg-success-100 icon-inner success-inner">
                  <ThumbsUp color="stroke-success-600" />
                </div>
              </div>
              <p>
                <span className="bold-text">{t('Patient.data.recommendations.useProper')}</span>
                <span> {t('Patient.data.recommendations.duringActivities')}</span>
              </p>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8}>
            <div className="recommendation-card success stroke-primary-700">
              <div className="bg-success-50 icon-wrapper success-icon">
                <div className="bg-success-100 icon-inner success-inner">
                  <ThumbsUp color="stroke-success-600" />
                </div>
              </div>
              <p>
                <span className="bold-text">{t('Patient.data.recommendations.engageGentle')}</span>
                <span> {t('Patient.data.recommendations.toHelp')}</span>
              </p>
            </div>
          </Col>
        </Row>

        <Row
          gutter={[16, 16]}
          style={{ marginTop: '16px', color: 'var(--text-color-root)' }}
        >
          <Col xs={24} sm={24} md={12} lg={8}>
            <div className="recommendation-card stroke-primary-700 error">
              <div className="bg-error-50 icon-wrapper error-icon">
                <div className="bg-error-100 icon-inner error-inner">
                  <ThumbsDown color="stroke-error-400" />
                </div>
              </div>
              <p>
                <span className="bold-text">{t('Patient.data.recommendations.doNotPush')} </span>
                <span>{t('Patient.data.recommendations.stopActivities')}</span>
              </p>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8}>
          <div className="recommendation-card stroke-primary-700 error">
              <div className="bg-error-50 icon-wrapper error-icon">
                <div className="bg-error-100 icon-inner error-inner">
                  <ThumbsDown color="stroke-error-400" />
                </div>
              </div>
              <p>
                <span className="bold-text">{t('Patient.data.recommendations.neglectEmotional')} </span>
                <span>{t('Patient.data.recommendations.stressAnxiety')}</span>
              </p>
            </div>
          </Col>
          <Col xs={24} sm={24} md={12} lg={8}>
          <div className="recommendation-card stroke-primary-700 error">
              <div className="bg-error-50 icon-wrapper error-icon">
                <div className="bg-error-100 icon-inner error-inner">
                  <ThumbsDown color="stroke-error-400" />
                </div>
              </div>
              <p>
                <span className="bold-text">{t('Patient.data.recommendations.avoidMovement')} </span>
                <span>{t('Patient.data.recommendations.inactivityWorsen')}</span>
              </p>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default RecommendationDashboard;
